import { onCLS, onFCP, onLCP, onTTFB, onINP } from 'web-vitals';
import type { Metric } from 'web-vitals';

const onPerformanceEntry = (metric: Metric) => {
  console.log(`${metric.name} recorded:`, metric);
};

const reportWebVitals = () => {
  const observer = new PerformanceObserver(list => {
    for (const entry of list.getEntries()) {
      if (entry.name === 'first-paint') {
        observer.disconnect();
      }

      console.log('FP recorded:', entry);
    }
  });
  observer.observe({ type: 'paint', buffered: true });

  onCLS(onPerformanceEntry);
  onINP(onPerformanceEntry);
  onFCP(onPerformanceEntry);
  onLCP(onPerformanceEntry);
  onTTFB(onPerformanceEntry);
};

export default reportWebVitals;
